import { getRecord } from "./getUserBattleRecord";
import {
  getOffenseIcon,
  getDisruptIcon,
  getSupportIcon,
  unlockSkin1Icon,
  unlockSkin2Icon
} from '../battle/ArenaView/SubmissionMenu/icon-svg-getters/icon-folder'

export const unlocks = [
  {
    id: "unlockA",
    icon: getOffenseIcon,
    name: "Bitslinger Class",
    requirementText: "Win 1 battle",
    completedText: "Won a battle!",

    getAcquiredNumber: function(record) {
      return record.totalWins;
    },
    requiredNumber: 1,

    test: function(record) {
      //Returns a 0 to 1 complete.
      return record.totalWins / 1;
    }
  },
  {
    id: "unlockB",
    icon: getDisruptIcon,
    name: "Infiltrator Class",
    requirementText: "Win 6 battles",
    completedText: "Won 6 battles!",

    getAcquiredNumber: function(record) {
      return record.totalWins;
    },
    requiredNumber: 6,

    test: function(record) {
      return record.totalWins / 6;
    }
  },
  {
    id: "unlockC",
    icon: unlockSkin1Icon,
    name: "Sunshine Skin",
    requirementText: "Win 3 Versus battles",
    completedText: "Won 3 Versus battles!",

    getAcquiredNumber: function(record) {
      return record.fullteamBattleWins;
    },
    requiredNumber: 3,

    test: function(record) {
      return record.fullteamBattleWins / 3;
    }
  },
  {
    id: "unlockD",
    icon: unlockSkin2Icon,
    name: "Hoodie Punk Skin",

    getAcquiredNumber: function(record) {
      return record.openBattleWins;
    },
    requiredNumber: 3,

    requirementText: "Win 3 Rally battles",
    completedText: "Won 3 Rally battles!",

    test: function(record) {
      return record.openBattleWins / 3;
    }
  },
  {
    id: "unlockE",
    icon: getSupportIcon,
    name: "Help Desk Class",
    requirementText: "Lose 3 battles",
    completedText: "Lost 3 battles!",

    getAcquiredNumber: function(record) {
      return record.totalLosses;
    },
    requiredNumber: 3,

    test: function(record) {
      return record.totalLosses / 3;
    }
  }
];

/** Return an array of IDs that you've unlocked */
export function getUserUnlocks() {
  const record = getRecord();
  // return unlocks.filter(unlock => {
  //   return unlock.test(record) >= 1 //EX: 6 wins / 5 needed = 1.2
  // }).map(unlock => {unlock.id}); //["unlockA", "unlockB"] etc

  const progressArray = unlocks.map(unlock => {
    let progress = unlock.test(record);
    if (progress > 1) {
      progress = 1; //max out at 1
    }

    return {
      id: unlock.id,

      acquiredNumber: unlock.getAcquiredNumber(record),
      requiredNumber: unlock.requiredNumber,

      progressPercent: Math.floor(progress * 100) + "%",
      isComplete: progress >= 1
    };
  });

  let payload = {};
  progressArray.forEach(progModel => {
    payload[progModel.id] = { ...progModel };
  });

  return payload;
}

//Get only the keys that I've completed
export function getUserUnlocksCompletedKeys() {
  const userUnlocks = getUserUnlocks();
  return Object.keys(userUnlocks).filter(key => {
    const model = userUnlocks[key];
    return model.isComplete
  });
}



// WEBPACK FOOTER //
// ./src/b5-unlocks/getUserUnlocks.js